
import { configureStore} from '@reduxjs/toolkit';
import rootReducer from '../rootreducer/index'
const store = configureStore({reducer: rootReducer})
export default store; 
/*
import { configureStore} from '@reduxjs/toolkit';
import rootReducer from '../rootreducer/index'
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from 'redux-persist'
  
  import storage from 'redux-persist/lib/storage';

  const persistConfig = {
    key: 'miCore',
    version: 1,
    storage,
    blacklist: ['securityReducer'],
  }

  const persistedReducer = persistReducer(persistConfig, rootReducer)

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })
  
  let persistor = persistStore(store)
  export const resetStore = async () => {
    await persistor.purge();
    store.dispatch(resetStore());
    await persistor.flush();
  };
export {persistor}

export default store; 
*/